import * as React from 'react'
import { Box, Icon, Grid } from '@design/pt-ui'

import Breadcrumb, { BreadcrumbItem } from '../../components/Breadcrumb'
import { Home as HomeIcon } from '@mui/icons-material'

import DI from '../../app/di'
import { translateWithUserLocale } from '../../utils/i18n'

import { PageProps as ProjectsDashboardPageProps } from '../../interfaces/pages/projects'

import Filter from './Filter'

import { useAdminFilter } from './Filter'
import PermissionPage from './PermissionPage'

export type IProps = ProjectsDashboardPageProps

function Layout(props: IProps) {
  const onBreadcrumbClick = (url: string) => {
    const history = DI.get('history')
    history.push(url)
  }

  const adminFilter = useAdminFilter()

  return (
    <Grid spacing={3} container={true}>
      <Grid size={12}>
        <Box sx={{ marginBottom: 1, marginTop: 1 }}>
          <Breadcrumb separatorText={<Icon>chevron_right</Icon>}>
            <BreadcrumbItem
              className="first-breadcrumb"
              sx={{
                display: 'flex',
                alignItems: 'center',
                '&.first-breadcrumb .MuiListItem-gutters, &.first-breadcrumb': {
                  paddingLeft: 0,
                },
              }}
              icon={<HomeIcon sx={{ mr: 0.5, width: 20, height: 20 }} />}
              label={translateWithUserLocale('projects_overview')}
              href="/projects"
              onClick={onBreadcrumbClick}
            />
          </Breadcrumb>
        </Box>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 12,
        }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: '15px',
            marginRight: '35px',
          }}>
          <h2>{translateWithUserLocale('user.management_title')}</h2>
        </Box>
      </Grid>
      <Grid size={12}>
        <Filter userGroups={props.user.groups} adminHook={adminFilter} />
      </Grid>
      <Grid size={12}>
        <PermissionPage adminFilter={adminFilter} {...props} />
      </Grid>
    </Grid>
  )
}

export default Layout
